

































import { Component, Mixins, Prop } from "vue-property-decorator";
import { ObjectUtility } from "../../../../../../utilities";
import JsonViewer from "../../../../../system/viewers/JsonViewer.vue";
import JsonEditor from "../../../../../system/editors/JsonEditor.vue";

@Component({
  components: {
    JsonViewer,
    JsonEditor,
  }
})
export default class BeanEditor extends Mixins() {
  @Prop()
  source: any;

  @Prop()
  reload: (source: any) => void;

  data(): any {
    return {
      editingSource: null,
    };
  }
  editingSource: any;  // editingSourceを直接更新すると編集中に逐次反映されてしまうのでcloneを編集する.

  get isEditable(): boolean {
    return !!this.source;
  }

  get isEditing(): boolean {
    return !!this.editingSource;
  }

  set isEditing(value: boolean) {
    this.editingSource = value
      ? ObjectUtility.copyDeeply(this.source)
      : null;
  }

  apply(): void {
    this.reload(this.editingSource);
    this.isEditing = false;
  }

  cancel(): void {
    this.isEditing = false;
  }
}
